/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-shadow */
/* eslint-disable array-callback-return */

import { Box, Grid } from '@mui/material';
import { withStyles } from '@material-ui/core';
import { compose } from 'recompose';
import { connect } from 'react-redux';
import React from 'react';

import { showToast } from 'modules/layout/layout.actions';
import { DRAWER_WIDTH_CLOSED, DRAWER_WIDTH_CLOSED_XS, DRAWER_WIDTH_OPEN } from 'styles/theme';

import HeaderCard from 'modules/authorizations/details/headerCard.component';
import CreateAuthCommentCard from './createAuthCommentCard.component';
import VoucherPreview from './voucherPreview.component';
import FeeInfoCard from './feeRecordCard.component';

const styles = theme => ({
  card: {
    width: '100%',
    maxWidth: 1500,
    flexGrow: 1,
    flexDirection: 'row',
    justifyContent: 'space-between'
  },
  cardContainer: {
    maxWidth: '100% !important',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between'
  },
  iconRow: { display: 'flex', flexDirection: 'row' },
  dialogIconRow: { display: 'flex', flexDirection: 'row', padding: '40px', paddingBottom: '20px' },
  cardDisplayContent: {
    maxWidth: '100% !important',
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    justifyContent: 'space-between',
    margin: '10px'
  },
  container: {
    height: 'auto',
    paddingLeft: theme.spacing(1),
    paddingRight: theme.spacing(1),
    whiteSpace: 'nowrap',
    width: `calc(100% - ${DRAWER_WIDTH_CLOSED_XS}px)`,
    [theme.breakpoints.up('sm')]: {
      width: `calc(100% - ${DRAWER_WIDTH_CLOSED}px)`
    }
  },
  drawerOpen: { width: `calc(100% - ${DRAWER_WIDTH_OPEN})` },
  headerFixed: { zIndex: 4 },
  tabFixed: { paddingTop: '100px', zIndex: 3 },
  estimateHeaderFixed: { paddingTop: '150px', zIndex: 2 }
});

const FeeDetails = props => {
  const {
    feeDetails,
    expenseCodes,
    enumerations,
  } = props;

  return (
    <Box>      
      <Box sx={{ paddingLeft: '16px', paddingTop: '10px' }}>
        <Grid container rowSpacing={2} columnSpacing={{ xs: 1, sm: 2, md: 2 }}>
          {feeDetails && (
            <>
              <Grid item xs={12} rowSpacing={2}>
                <HeaderCard clientInfo={props.clientInfo} enumerations={enumerations.allEnums} details={feeDetails.authorizationFile} id={feeDetails.authorizationFile.fileId} emailTemplate={props.emailTemplate} isReadOnly={true} />
              </Grid>
              <Grid item xs={12} xl={8} rowSpacing={2}>
                <FeeInfoCard feeRecordDetails={feeDetails.feeDetails} feeRule={feeDetails.feeRule} enumerations={enumerations.allEnums} />
              </Grid>
              <Grid item xs={12} xl={4} rowSpacing={2}>
                <CreateAuthCommentCard feeRecordDetails={feeDetails.feeDetails} feeRule={feeDetails.feeRule} feeComments={feeDetails.comments} authorizationDetails={feeDetails.authorizationFile} enumerations={enumerations.allEnums} />
              </Grid>

              <Grid item xs={12} rowSpacing={2}>
                <VoucherPreview authorizationDetails={feeDetails.authorizationFile} expenseCodes={expenseCodes} voucherDetails={feeDetails.voucher} enumerations={enumerations.allEnums} />

              </Grid>
            </>
          )}
        </Grid>
      </Box>
    </Box>
  );
};

const mapStateToProps = state => {
  const {
    authorizations: { vendors },
    fees: { feeDetails, feeRecordId },
  } = state;
  return { vendors, feeDetails, feeRecordId };
};

export default compose(withStyles(styles), connect(mapStateToProps, { showToast }))(FeeDetails);
